<template>
  <div :class="['spinner-container', { small: small }]">
    <i class="fas fa-circle-notch fa-spin" />
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.spinner-container {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #3c4b64;
}

.spinner-container:not(.small) {
  font-size: 3rem;
}

.spinner-container.small {
  font-size: 1rem;
}

.fa-spin {
  animation: fa-spin 1s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
</style>
